import {add} from 'date-fns'

const defaultFilters = {
  createdAtFrom: null,
  createdAtTo: add(new Date(), {days: 1}),
  searchString: ''
}

export {defaultFilters}
